import React from 'react';
import { motion } from 'framer-motion';
import { SparklesIcon } from 'lucide-react';
export function FinalCTA() {
  return <section className="py-24 px-4 bg-white relative overflow-hidden pt-[15px] pb-[50px]" data-id="element-1">
      {/* Decorative elements */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-px h-24 bg-gradient-to-b from-transparent to-gold/30" data-id="element-2" />

      <div className="max-w-4xl mx-auto text-center space-y-10 relative z-10" data-id="element-3">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="space-y-6" data-id="element-4">
          <h2 className="text-4xl md:text-6xl font-bold text-text-dark leading-tight" data-id="element-5">
            Elegí el camino que más <br data-id="element-6" />
            <span className="italic text-[#4A3B6B]" data-id="element-7">resuene con vos</span>
          </h2>
          <p className="text-xl text-text-muted max-w-2xl mx-auto leading-relaxed" data-id="element-8">
            Cada programa tiene acceso digital, material organizado y recursos
            listos para consultar desde cualquier dispositivo.
          </p>
        </motion.div>

        {/* Modified section with button including hover effects and animated background */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} data-id="element-9">
          <motion.button onClick={() => window.scrollTo({
          top: 0,
          behavior: 'smooth'
        })} whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} className="relative btn-primary text-xl px-12 overflow-hidden group/btn bg-gradient-to-r from-[#4A3B6B] via-[#6B5A8E] to-[#4A3B6B] bg-[length:200%_auto] hover:bg-right transition-all duration-500 hover:shadow-[0_0_30px_rgba(74,59,107,0.4)]" data-id="element-10">
            {/* Background shimmer effect */}
            <motion.div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover/btn:animate-[shimmer_1.5s_infinite]" style={{
            skewX: '-20deg'
          }} data-id="element-11" />
            {/* Button content with sparkle icon and label */}
            <span className="relative flex items-center gap-2" data-id="element-12">
              <SparklesIcon className="w-6 h-6 text-gold animate-pulse" data-id="element-13" />
              Explorar programas
            </span>
          </motion.button>
        </motion.div>
      </div>

      {/* Soft background glow */}
      <div className="absolute bottom-[-20%] left-1/2 -translate-x-1/2 w-[60%] h-[60%] bg-lavender/20 rounded-full blur-[120px] -z-0" data-id="element-14" />
    </section>;
}